import config from 'config';
import routes from './routes';
import constants from 'constants';
import store from './store';
import axios from 'axios';
import html2canvas from 'html2canvas';

const apiEndpoint = config.baseAPIURL;

class HttpRequest {

  constructor() {
      this.httpValidation();
  }

  httpValidation() {
    console.log("This happened");
    let user = PortalUser.getUserAuthDetail(); // get user credential
    this.token = user.token;

    if (this.token == null) {
        // alert("No token found... Redirecting to login page")
        // you can redirect user to the login page or show some error message
        this.httpRedirect('login')
    }
  }

  httpRedirect(name) {
    // add redirect route here

    return false;
  }

  static async getAll(url) {
    let httpRequest = new HttpRequest();
    const response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null);
    console.info('getAll', response);
    return response;
  }

  static async getById(model, id){
    let httpRequest = new HttpRequest();
    const response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${model}/${id}/`, null);
    console.info('getById', response);
    return response;
  }

  buildEndpoint(path, id) {
     let endpoint = path
     if(id != null)
       endpoint = endpoint.concat(id);
     return endpoint.substr(-1) == '/' ? endpoint : endpoint.concat('/');
   }

  getRequestType(type) {
    let method;
    switch(type) {
      case 'post':
        method = "POST";
        break;
      case 'put':
        method = "PUT";
        break;
      case 'delete':
        method = "DELETE";
        break;
      default:
        method = "GET";
    }
    return method;
  }


  async sendRequest(type, endpoint, data) {
    let response;
    let request = this.getRequestType(type);
    let content_type = (request == "GET")? 'text/plain' : 'application/json';
    console.log("Sending " + request + " request to: " + endpoint);

    if (data != null)
      data = JSON.stringify(data);

    try {
      await $.ajax({
        url: endpoint,
        type: request,
        data: data,
        contentType: content_type,
        headers: {'Authorization': `Token ${this.token}`},
        success: function (data, text, rq) {
          if(data){
            response = data;
          }else{
            response = {status:rq.status};
          }
        },
      });
    } catch(e) {
      console.log("Unable to get a " + request+ " response from: "+ endpoint);
      console.log(e)
      if (e.responseJSON.hasOwnProperty('errors')){
        response = e.responseJSON;
      } else {
        if (e.status == 401) store.dispatch('logoutUser');
        response = null;
      }
    }
    return response;
  }


  async sendDocRequest(type, endpoint, data) {
    var request = new XMLHttpRequest();

    try {

      let response = await $.ajax({
        url: endpoint,
        data: data,
        processData: false,
        contentType: false,
        headers: {'Authorization': `Token ${this.token}`},
        type: type,
        success: function (data) {
          response = data;
        },
      });
      return response
    } catch(e) {
      console.log("Unable to get a " + request+ " response from: "+ endpoint);
    }
    return response;
  }
}

class Config {

  static async getLayoutForView(viewName) {
    let response, url = `${apiEndpoint}/`;
    let httpRequest = new HttpRequest();
    try {
      response = await httpRequest.sendRequest( 'get', `${config.baseAPIURL}/layoutconfig/?name=${viewName}`, null);
      console.log("Layout: ", response)
    } catch(e) {
      response = null;
    }
    return response;
  }
}
class Indicator{
  static async getAllIndicators() {
    let response = null;
    let httpRequest = new HttpRequest();
    try {
     response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/indicators/`, null); // request data from api
     console.log("Indicators: ", response)
    } catch(e) {
      console.log('unable to get Indicator list: ', e);
    }
    return response;
  }

  static async getSelectedIndicator(indicator_id) {
    let response = null;
    let httpRequest = new HttpRequest();
    try {
      response = await httpRequest.sendRequest(
        'get',
        `${config.baseAPIURL}/indicators/${indicator_id}/`,
        null
      );

      console.log("Selected indicator: ", response);
    } catch(e) {
      console.log('unable to get selected indicator: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async createNewIndicator(indicator) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/indicators/`, null); // get api endpoint

    try {
        response = await httpRequest.sendRequest('post', url, indicator);
        console.log("Created Mea: ", response);
    } catch(e) {
        console.log('unable to create new mea: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async updateSelectedIndicator(indicator) {
      let response = null;
      let httpRequest = new HttpRequest();

      console.log("Indicator: ", indicator);
      let url = httpRequest.buildEndpoint('indicators/', indicator.id); // get api endpoint

      try {
          response = await httpRequest.sendRequest('put', `${config.baseAPIURL}/${url}`, indicator);
          console.log("Updated Indicator: ", response);
      } catch(e) {
          console.log('unable to update selected indicator: ', e);
      }
      return response; //return the relevant data from the json response
  }

  static async deleteSelectedIndicator(indicator) {
      let response = null;
      let res = 'success';
      let httpRequest = new HttpRequest();
      let url = httpRequest.buildEndpoint('indicators/', indicator.id); // get api endpoint

      try {
        response = await httpRequest.sendRequest('delete', `${config.baseAPIURL}/${url}`, null);
        console.log("Deleted Indicator: ", response);
        if (response && response.status != 204)
          res = 'failed';
      } catch(e) {
          res ='failed';
          console.log('unable to delete selected indicator: ', e);
      }
      return res; //return the relevant data from the json response
  }

  static async getIndicatorCategories(){
    let response = await HttpRequest.getAll('indicators/categories/');
    let formattedResponse = [];
    if (response !== undefined){
      for (let item in response){
        let formattedResponseItem = {'mea': item, 'categories': []}
        for(let sub_item in response[item]){
          formattedResponseItem['categories'].push({value: sub_item, label: response[item][sub_item]})
        }
        formattedResponse.push(formattedResponseItem);
      }
    }
    console.log('Formatted Response ');
    console.log(formattedResponse);
    return formattedResponse;
  }

  static async getIndicatorPriorities(){
    let response = await HttpRequest.getAll('indicators/priorities/');
    let formattedResponse = [];
    if (response !== undefined){
      for (let item in response){
        formattedResponse.push({'value': item, 'label':response[item]});
      }
    }
    console.log('Formatted Response ');
    console.log(formattedResponse);
    return formattedResponse;
  }
}

class Category{
  static async getAllCategories(){
    let response = await HttpRequest.getAll('categories/');
    return response;
  }
}
class GenericUpdateCreate {
  static async update (data, route, id) {
    let endpoint = `${config.baseAPIURL}/${route}/${id}/`;
    let httpRequest = new HttpRequest();
    response = await httpRequest.sendRequest('put', endpoint, data);
    return response;
  }
  static async create (data, route) {
    let endpoint = `${config.baseAPIURL}/${route}/`
    let httpRequest = new HttpRequest();
    let response = await httpRequest.sendRequest('post', endpoint, data);
    return response;
  }
  static async delete (route, id) {
    let endpoint = `${config.baseAPIURL}/${route}/${id}/`
    let httpRequest = new HttpRequest();
    let response = await httpRequest.sendRequest('delete', endpoint);
    return response;
  }
}

class PortalUser {
  static async login(email, password) {
    let response;
    const url = config.baseAuthURL + 'login/';
    const data = {
      email: email,
      password: password
    };
    try {
       response = await $.ajax({
          method: 'POST',
          url: url,
          data: JSON.stringify(data),
          processData: false,
          contentType: 'application/json',
          success: function(payload){
            localStorage.email = payload.user.email;
            localStorage.token = payload.token;
            return payload;
          },
          error: function( jqXhr, textStatus, errorThrown ){
            console.log( errorThrown );
            return false;
          }
        });
       return response;
    } catch(e) {
      return false;
    }
  }

  static async forgotPassword(email) {
    let response, httpRequest = new HttpRequest();
    const url = `forgot-password/`;
    let data = { email: email};
    try {
       response = await httpRequest.sendRequest('post',`${config.baseAuthURL}${url}`, data);
       console.log("Updated User: ", response);
    } catch(e) {
      response = null;
    }
    return response;
  }

  static async resetPassword(uid, token, data) {
    let response, httpRequest = new HttpRequest();
    const url = `reset-password/${uid}/${token}/`;
    try {
       response = await httpRequest.sendRequest('post',`${config.baseAuthURL}${url}`, data);
       console.log("Updated User: ", response);
    } catch(e) {
      response = null;
    }
    return response;
  }

  static async update(id, data) {
    let response, httpRequest = new HttpRequest();
    const url = `users/${id}/`;
    try {
       response = await httpRequest.sendRequest('put',`${config.baseAPIURL}/${url}`, data);
       console.log("Updated User: ", response);
    } catch(e) {
      response = null;
    }
    return response;
  }

  static async inviteUsers(data) {
    let httpRequest = new HttpRequest();
    let response = await httpRequest.sendRequest(
      'post',
      `${config.baseAuthURL}invite-user/`,
      data
    );
    return response;
  }

  static loggedIn(){
    return !localStorage.email;
  }

  static getUserAuthDetail() {
    let data, email, token;

    try {
        email = localStorage.email;
        token = localStorage.token;
        data = { 'email': email, 'token': token };
    } catch (e) {
        console.log('no user data found: ',  e);
        data = null;
    }

    return data;
  }

  static async getUser(){
    // May throw an error if the token does not exist in local storage
    const token = localStorage.token;
    let response = null;
    let httpRequest = new HttpRequest();
    try {
       response = await httpRequest.sendRequest('get',`${config.baseAuthURL}getbytoken/${token}/`, null);
    } catch(e) {
      console.log(e);
    }
    console.log('Got user by id: ', response);
    return response;
  }

  // user to get id/pk of current/selected customer
  static getCurrentUserId() {
    return this.$route.params.id;
  }

  static logOut(){
    localStorage.token = config.appToken;
    localStorage.email = null;
  }

  static async getAll() {
    console.log("Fetching users from the API");
    let httpRequest = new HttpRequest();
    // const response = await HttpRequest.sendGetRequest("users/");
    const response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/users/`, null);
    console.info('getAlls', response)
    return response;
  }

  static async getById(id) {
    let httpRequest = new HttpRequest();
    const response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/users/${id}/`, null);
    return response;
  }

    static async delete(user) {
      let response = null;
      let res = 'success';
      let httpRequest = new HttpRequest();
      let url = httpRequest.buildEndpoint('users/', user.id); // get api endpoint

      try {
        response = await httpRequest.sendRequest('delete', `${config.baseAPIURL}/${url}`, null);
        console.log("Deleted User: ", response);
        if (response && response.status != 204)
          res = 'failed';
      } catch(e) {
          res='failed';
          console.log('unable to delete selected user: ', e);
      }
      return res; //return the relevant data from the json response
  }
}


class Reminder {
    static async getAllReminders() {
        let response = null;
        let httpRequest = new HttpRequest()
        let url = httpRequest.buildEndpoint('reminders/', null); // get api endpoint

        try {
            response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null); // request data from api
        } catch(e) {
            console.log('unable to get reminder list: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async getSelectedReminder(reminder_id) {
      let response = null;
      let httpRequest = new HttpRequest()
      let url = httpRequest.buildEndpoint('reminders/', reminder_id); // get api endpoint
      try {
          response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null);
      } catch(e) {
          console.log('unable to get selected reminder: ', e);
      }
      return response; //return the relevant data from the json response
  }

  static async updateSelectedReminder(reminder) {
      let response = null;
      let httpRequest = new HttpRequest()
      let url = httpRequest.buildEndpoint('reminders/', reminder.id); // get api endpoint

      try {
          response = await httpRequest.sendRequest('put', `${config.baseAPIURL}/${url}`, reminder);
      } catch(e) {
          console.log('unable to update selected reminder: ', e);
      }
      return response; //return the relevant data from the json response
  }

  // static async deleteSelectedReminder(id, reminder) {
  //     let response = null;
  //     let httpRequest = new HttpRequest()
  //     let url = httpRequest.buildEndpoint('reminder/', reminder.id); // get api endpoint

  //     try {
  //         response = await httpRequest.sendRequest('delete', `${config.baseAPIURL}/${url}`, null);
  //     } catch(e) {
  //         console.log('unable to delete selected reminder: ', e);
  //     }
  //     return response; //return the relevant data from the json response
  //   }

  static async getStatuses(){
      let response = null;
      let httpRequest = new HttpRequest();
      let url = httpRequest.buildEndpoint('reminders/statuses', null);
      try {
        response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null);
      } catch (e){
        console.log('Unable to get reminder statuses: ', e);
      }
      return response;
  }

}

class Organization {

    static async getAllOrganizations() {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint('organizations/', null); // get api endpoint

        try {
            response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null); // request data from api
            console.log("All Organizations: ", response);
        } catch(e) {
            console.log('unable to get organization list: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async createNewOrganization(organization) {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint('organizations/', null); // get api endpoint

        try {
            response = await httpRequest.sendRequest('post', `${config.baseAPIURL}/${url}`, organization);
            console.log("Created Organization: ", response);
        } catch(e) {
            console.log('unable to create new organization: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async getSelectedOrganization(organization_id) {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint('organizations/', organization_id); // get api endpoint
        try {
            response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null);
            console.log("Selected Organization: ", response);
        } catch(e) {
            console.log('unable to get selected organization: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async updateSelectedOrganization(organization) {
        let response = null;
        let httpRequest = new HttpRequest()

        console.log("Organization: ", organization);
        let url = httpRequest.buildEndpoint('organizations/', organization.id); // get api endpoint

        try {
            response = await httpRequest.sendRequest('put', `${config.baseAPIURL}/${url}`, organization);
            console.log("Updated Organization: ", response);
        } catch(e) {
            console.log('unable to update selected organization: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async deleteSelectedOrganization(organization) {
        let response = null;
        let res = 'success';
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint('organizations/', organization.id); // get api endpoint
        try {
          response = await httpRequest.sendRequest('delete', `${config.baseAPIURL}/${url}`, null);
          console.log("Deleted Organization: ", response);
          if (response && response.status != 204)
            res = 'failed';
        } catch(e) {
          res = 'failed';
            console.log('unable to delete selected organization: ', e);
        }
        return res; //return the relevant data from the json response
    }
}

class MOU {

  static async getAllMous() {
    let response = null;
    let httpRequest = new HttpRequest()
    let url = httpRequest.buildEndpoint('mous/', null); // get api endpoint
    try {
        response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null); // request data from api
    } catch(e) {
        console.log('unable to get Mou list: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async getMou(mou_id) {
    let response = null;
    let httpRequest = new HttpRequest()
    let url = httpRequest.buildEndpoint(`mous/`, mou_id); // get api endpoint
    try {
        response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null);
    } catch(e) {
        console.log('unable to get selected mou: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async createNewMou(mou) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/mous/`, null); // get api endpoint
    try {
        response = await httpRequest.sendRequest('post', url, mou);
        console.log("Created Mou: ", response);
    } catch(e) {
        console.log('unable to create new mou: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async getMouStatus(){
    let response = await HttpRequest.getAll('mous/status/');
    let formattedResponse = [];
    if (response !== undefined){
      for (let item in response){
        formattedResponse.push({'value': item, 'label':response[item]});
      }
    }
    return formattedResponse;
  }

  static async updateMou(id, mou) {
    let response = null;
    let httpRequest = new HttpRequest()
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/mous/`, mou.id); // get api endpoint
    try {
        response = await httpRequest.sendRequest('put', url, mou);
    } catch(e) {
        console.log('unable to update selected mou: ', e);
    }
    return response; //return the relevant data from the json response
  }
  static async deleteMou(id, mou) {
    let response = null;
    let res = 'success';
    let httpRequest = new HttpRequest()
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/mous/`, mou.id); // get api endpoint
    try {
        response = await httpRequest.sendRequest('delete', url, null);
        console.log("Deleted Mou: ", response);
        if (response && response.status != 204)
          res = 'failed';
    } catch(e) {
      res ='failed';
      console.log('unable to delete selected mou: ', e);
    }
    return res; //return the relevant data from the json response
  }
}

class MEA {
  static async getAllMeas() {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint('meas/', null); // get api endpoint
    try {
        response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/${url}`, null); // request data from api
        console.log('All Meas: ', response);
    } catch(e) {
        console.log('unable to get Mea list: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async createNewMea(mea) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/meas/`, null); // get api endpoint
    try {
      var formData = new FormData();
      let fileInputElement = document.getElementById("mea-document");

      formData.append("document", fileInputElement.files[0]);
      formData.append("name", mea.name);
      formData.append("color", mea.color);
      formData.append("abbreviation", mea.abbreviation);
      formData.append("description", mea.description);
      mea.categories.forEach(function(category){
        formData.append('categories', category['name']);
      });
      response = await httpRequest.sendDocRequest('post', url, formData);
        console.log("Created Mea: ", response);
    } catch(e) {
        console.log('unable to create new mea: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async getSelectedMea(mea_id) {
    let response = null;
    let httpRequest = new HttpRequest()
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/meas/`, mea_id); // get api endpoint
    try {
        response = await httpRequest.sendRequest('get', url, null);
    } catch(e) {
        console.log('unable to get selected mea: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async updateSelectedMea(mea) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/meas/`, mea.id); // get api endpoint
    try {
      var formData = new FormData();
      let fileInputElement = document.getElementById("mea-document");

      if (fileInputElement.files[0] !== undefined){
        formData.append("document", fileInputElement.files[0]);
      }
      formData.append("name", mea.name);
      formData.append("color", mea.color);
      formData.append("abbreviation", mea.abbreviation);
      formData.append("description", mea.description);
      mea.categories.forEach(function(category){
        formData.append("categories", category['name']);
      });

      response = await httpRequest.sendDocRequest('put', url, formData);
    } catch(e) {
        console.log('unable to update selected mea: ', e);
    }
    return response; //return the relevant data from the json response
  }
  static async deleteSelectedMea(mea) {
    let response = null;
    let res = 'success';
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/meas/`, mea.id); // get api endpoint
    try {
        response = await httpRequest.sendRequest('delete', url, null);
        console.log("Deleted Report: ", response);
        if (response && response.status != 204)
          res = 'failed';
    } catch(e) {
        res = 'failed';
        console.log('unable to delete selected mea: ', e);
    }
    return res; //return the relevant data from the json response
  }
}

class Group {

  static async getAllGroups() {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/groups/`, null); // get api endpoint

    try {
        response = await httpRequest.sendRequest('get', url, null); // request data from api
        console.log("All Groups: ", response);
    } catch(e) {
        console.log('unable to get group list: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async createNewGroup(group) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/groups/`, null); // get api endpoint

    try {
        response = await httpRequest.sendRequest('post', url, group);
        console.log("Created Group: ", response);
    } catch(e) {
        console.log('unable to create new group: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async getSelectedGroup(group_id) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/groups/`, group_id); // get api endpoint

    try {
        response = await httpRequest.sendRequest('get', url, null);
        console.log("Selected Group: ", response);
    } catch(e) {
        console.log('unable to get selected group: ', e);
    }
    return response; //return the relevant data from the json response
  }


  static async updateSelectedGroup(id, group) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/groups/`, group.id); // get api endpoint

    try {
        response = await httpRequest.sendRequest('put', url, group);
        console.log("Updated Group: ", response);
    } catch(e) {
        console.log('unable to update selected group: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async deleteSelectedGroup(group) {
    let response = null;
    let res = 'success';
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/groups/`, group.id); // get api endpoint

    try {
        response = await httpRequest.sendRequest('delete', url, null);
        console.log("Deleted Group: ", response);
        if (response && response.status != 204)
          res = 'failed';
    } catch(e) {
        res = 'failed';
        console.log('unable to delete selected group: ', e);
    }
    return res; //return the relevant data from the json response
  }
}

class ReportWizard {
  static async getXLSReportData () {
    let response = null;
    let uri = `${config.baseURL}/report/fetch-xls-report-data`;
    let config_object = {
      responseType: 'json',
      headers: {
        'Authorization': `Token ${localStorage.token}`
      }
    };
    await axios.post(
      uri,
      {reportName:store.state.reportObject.name},
      config_object
    ).then(function (_response) {
      response = _response.data;
    }).catch(function(error){
      console.log(error);
    });
    return response
  }
  static async fetchFilForPreview() {
    let response = null;
    let uri = `${config.baseURL}/report/download-file-preview/?file=${store.state.reportObject.name}`;
    let config_object = {
      responseType: 'arraybuffer',
      headers: {
        'Authorization': `Token ${localStorage.token}`
      }
    };
    await axios.get(
      uri,
      {reportName: store.state.reportObject.name},
      config_object
    ).then(function (_response) {
      response = _response.data;
    }).catch(function(error){
      console.log(error);
    });
    return response
  }
  static async downloadReport(data){
    let response = null;
    let uri = `${config.baseURL}/report/download-report`;
    let config_object = {
      responseType: 'arraybuffer',
      headers: {
        'Authorization': `Token ${localStorage.token}`
      }
    };
    await axios.post(
      uri,
      data,
      config_object
    ).then(function (response) {
      console.log('MATH', response)
      const url = window.URL.createObjectURL(
        new Blob([response.data])
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${store.state.reportObject.name}.zip`);
      document.body.appendChild(link);
      link.click();
    }).catch(function (error) {
      console.log(error);
    });
  }

  static async fetchIndicatorsByMeaId(id) {
    let httpRequest = new HttpRequest();
    let response = null;
    try {
      response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/indicators/?mea_id=${id}`, null);
    } catch(e) {
      console.log(e)
    }
    console.log("fetchIndicatorsByMeaId: ", response)
    return response;
  }

  static async fetchDataSourceByIndicatorId(id) {
    let httpRequest = new HttpRequest();
    let response = null;
    try {
      response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/data-sources/?indicator_id=${id}`, null);
    } catch(e) {
      console.log(e)
    }
    console.log("fetchDataSourceByIndicatorId: ", response)
    return response;
  }

  static async createReport(payload){
    let httpRequest = new HttpRequest();
    try {
      let response = await httpRequest.sendRequest('post', `${config.baseURL}/report/create`, payload);
      return response;
    } catch (e) {
      console.log(e);
    }
  }

  static async getSelectedReport(report_id) {
    let response = null;
    let httpRequest = new HttpRequest();
    try {
        response = await httpRequest.sendRequest(
          'post',
          `${config.baseURL}/report/get-report`,
          {'report_id': report_id}
        );
        console.log("Selected Report: ", response);
    } catch(e) {
      console.log('unable to get selected report: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async deleteSelectedReport(id) {
      let response = null;
      let res = 'success';
      let httpRequest = new HttpRequest();
      let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/reports/`, id); // get api endpoint
      try {
        response = await httpRequest.sendRequest('delete', url, null);
        console.log("Deleted Report: ", response);
        if (response && response.status != 204)
          res = 'failed';
      } catch(e) {
        res = 'failed';
        console.log('unable to delete selected report: ', e);
      }
      return res; //return the relevant data from the json response
  }
}

class Role {
    static async getAllRoles() {
        let response = null;
        let httpRequest = new HttpRequest();
        try {
            response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/roles/`, null); // request data from api
            console.log("All Roles: ", response);
        } catch(e) {
            console.log('unable to get role list: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async getSelectedRole(role_id) {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/roles/`, role_id); // get api endpoint
        try {
            response = await httpRequest.sendRequest('get', url, null);
            console.log("Selected Role: ", response);
        } catch(e) {
            console.log('unable to get selected role: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async createNewRole(role) {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/roles/`, null); // get api endpoint

        try {
            response = await httpRequest.sendRequest('post', url, role);
            console.log("Created Role: ", response);
        } catch(e) {
            console.log('unable to create new role: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async updateSelectedRole(role) {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/roles/`, role.id); // get api endpoint

        try {
            response = await httpRequest.sendRequest('put', url, role);
            console.log("Updated Role: ", response);
        } catch(e) {
            console.log('unable to update selected role: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async deleteSelectedRole(role) {
        let response = null;
        let res = 'success';
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/roles/`, role.id); // get api endpoint

        try {
          response = await httpRequest.sendRequest('delete', url, null);
          console.log("Deleted Role: ", response);
          if (response && response.status != 204)
            res = 'failed';
        } catch(e) {
            res = 'failed';
            console.log('unable to delete selected role: ', e);
        }
        return res; //return the relevant data from the json response
    }
}

class DataSource {
  static async getAllDataSources(){
    return await HttpRequest.getAll('data-sources/')
  }

  static async getDataSourceById(id){
    return await HttpRequest.getById('data-sources', id);
  }

  static async createDataSource(data_source){
    let httpRequest = new HttpRequest();
    try {
      let response = httpRequest.sendRequest(
        'post',
        `${config.baseAPIURL}/data-sources/`,
        data_source);
      return response;
    } catch (e) {
      condole.log('Unable to create new data source');
    }
    return null;
  }

  static async getAcceptedDataTypes(){
    let response = await HttpRequest.getAll('data-sources/accepted_data_types/')
    let formatted_response = [];
    if (response !== undefined){
      for (let item in response){
        formatted_response.push({'value': item, 'label': response[item]});
      }
    }
    console.log('Formatted Response ');
    console.log(formatted_response);
    return formatted_response;

  }

  static async deleteSelectedDataSource(data_source){
    let response = null;
    let res = 'success';
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint('data-sources/', data_source.id);

    try{
      response = await httpRequest.sendRequest('delete', `${config.baseAPIURL}/${url}`, data_source);
      console.log("Deleted DataSource: ", response);
        if (response && response.status != 204)
          res = 'failed';
    } catch(e){
      res = 'failed';
      console.log('Unable to update selected Data Source');
    }
    return res;
  }

  static async updateSelectedDataSource(data_source){
    let response = null;
    let httpRequest = new HttpRequest();

    console.log('Data Source: ', data_source);
    let url = httpRequest.buildEndpoint('data-sources/', data_source.id);

    try{
      response = await httpRequest.sendRequest('put',`${config.baseAPIURL}/${url}`, data_source);
      console.log('Deleted Indicator: ', response);
    } catch (e) {
      console.log('unable to delete selected data source', e);
    }
    return response;

  }
}

class Permission {
    static async getAllPermissions() {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/permissions/`, null); // get api endpoint

        try {
            response = await httpRequest.sendRequest('get', url, null); // request data from api
            console.log("All Permissions: ", response);
        } catch(e) {
            console.log('unable to get permission list: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async getSelectedPermission(permission_id) {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/permissions/`, permission_id); // get api endpoint
        try {
            response = await httpRequest.sendRequest('get', url, null);
            console.log("Selected Permission: ", response);
        } catch(e) {
            console.log('unable to get selected permission: ', e);
        }
        return response; //return the relevant data from the json response
    }
}
class Tag {

  static async getAllTags() {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/tags/`, null); // get api endpoint

    try {
        response = await httpRequest.sendRequest('get', url, null); // request data from api
        console.log("All Tags: ", response);
    } catch(e) {
        console.log('unable to get tag list: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async createNewTag(tag) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/tags/`, null); // get api endpoint

    try {
        response = await httpRequest.sendRequest('post', url, tag);
        console.log("Created Tag: ", response);
    } catch(e) {
        console.log('unable to create new tag: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async getSelectedTag(tag_id) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/tags/`, tag_id); // get api endpoint

    try {
        response = await httpRequest.sendRequest('get', url, null);
    } catch(e) {
        console.log('unable to get selected tag: ', e);
    }
    return response; //return the relevant data from the json response
  }


  static async updateSelectedTag(id, tag) {
    let response = null;
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/tags/`, tag.id); // get api endpoint

    try {
        response = await httpRequest.sendRequest('put', url, tag);
        console.log("Updated Tag: ", response);
    } catch(e) {
        console.log('unable to update selected tag: ', e);
    }
    return response; //return the relevant data from the json response
  }

  static async deleteSelectedTag(tag) {
    let response = null;
    let res = 'success';
    let httpRequest = new HttpRequest();
    let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/tags/`, tag.id); // get api endpoint

    try {
        response = await httpRequest.sendRequest('delete', url, null);
        console.log("Deleted Tag: ", response);
        if (response && response.status != 204)
          res = 'failed';
    } catch(e) {
      res = 'failed';
        console.log('unable to delete selected getTags: ', e);
    }
    return res; //return the relevant data from the json response
  }
}

class SignedOff {
    static async getAllSignedOffs() {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/signed_offs/`, null); // get api endpoint

        try {
            response = await httpRequest.sendRequest('get', url, null); // request data from api
            console.log("All SignedOffs: ", response);
        } catch(e) {
            console.log('unable to get signedoff list: ', e);
        }
        return response; //return the relevant data from the json response
    }

    static async getSelectedSignedOff(signedoff_id) {
        let response = null;
        let httpRequest = new HttpRequest();
        let url = httpRequest.buildEndpoint(`${config.baseAPIURL}/signed_offs/`, signedoff_id); // get api endpoint
        try {
            response = await httpRequest.sendRequest('get', url, null);
            console.log("Selected Signedoff: ", response);
        } catch(e) {
            console.log('unable to get selected signedoff: ', e);
        }
        return response; //return the relevant data from the json response
    }
}


class Page {

    static async getAssociatedPageContent() {
        let response = null;
        let httpRequest = new HttpRequest();

        try {
            response = await httpRequest.sendRequest('get', `${config.baseAPIURL}/page-content/`, null); // request data from api
            console.log("All associated page content: ", response);
        } catch(e) {
            console.log('unable to get associated page content: ', e);
        }
        return response; //return the relevant data from the json response
    }
}

window.PortalUser = PortalUser;
export {
  Config, PortalUser, Reminder, Organization, GenericUpdateCreate,
  HttpRequest, Group, Role, MOU, MEA, Permission, SignedOff, Tag,
  ReportWizard, Indicator, DataSource, Page, Category
}



// WEBPACK FOOTER //
// ./src/api.js